/*
 * Jira Ticket:
 * Created Date: Wed, 11th Mar 2020, 14:31:20 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { required, SelectInput, TextInput } from 'react-admin';
import { columnStyles } from 'styles';
import { booleanOptions } from 'utils/choices';
import { isSuperAdmin, isSuperManager, isManager } from 'utils/roles';
import { isValidPhoneNumber, isValidEmail } from 'utils/validation';

const OverviewTab = ({ allowChecklist, permissions, ...props }) => {
  const classes = columnStyles();
  const superAdmin = isSuperAdmin(permissions);
  const superManager = isSuperManager(permissions, props.id);
  const manager = isManager(permissions, props.id);

  const emailValidation = [required(), email => isValidEmail(email)];

  return (
    <div className={classes.root}>
      <div className={classes.column}>
        <TextInput
          source="name"
          label={'resources.Organisation.fields.orgName'}
          disabled={!superManager}
          validate={required()}
        />
        {manager ? (
          <SelectInput
            source="projectAccess"
            label={'resources.Organisation.fields.projectAccess'}
            defaultValue={false}
            disabled={!superAdmin}
            choices={booleanOptions}
            validate={required()}
          />
        ) : null}
      </div>
      <div className={classes.column}>
        <TextInput
          source="contact.name"
          disabled={!superManager}
          validate={required()}
          label={'resources.Organisation.fields.pocName'}
        />
        <TextInput
          source="contact.position"
          disabled={!superManager}
          validate={required()}
          label={'resources.Organisation.fields.pocPosition'}
        />
        <TextInput
          source="contact.email"
          disabled={!superManager}
          validate={emailValidation}
          label={'resources.Organisation.fields.pocEmail'}
        />
        <TextInput
          source="contact.phone"
          disabled={!superManager}
          validate={phone => isValidPhoneNumber(phone)}
          label={'resources.Organisation.fields.pocNum'}
        />
      </div>
      <div className={classes.column}>
        <TextInput
          source="addressLine1"
          validate={required()}
          disabled={!superManager}
          label={'resources.Organisation.fields.addressOne'}
        />
        <TextInput
          source="addressLine2"
          disabled={!superManager}
          label={'resources.Organisation.fields.addressTwo'}
        />
        <TextInput
          source="city"
          validate={required()}
          disabled={!superManager}
          label={'resources.Organisation.fields.city'}
        />
        <TextInput
          source="postCode"
          validate={required()}
          disabled={!superManager}
          label={'resources.Organisation.fields.postcode'}
        />
        <TextInput
          source="country"
          validate={required()}
          disabled={!superManager}
          label={'resources.Organisation.fields.country'}
        />
      </div>
    </div>
  );
};

export default OverviewTab;
